export const SALES_PROCESS_FALLBACK = "*-";

export const SALES_PROCESS_STEPS = [
    { key: 'SOLICITUD_VISITA', title: 'Solicitud de Visita', number: '01' },
    { key: 'GESTION_VISITA', title: 'Gestión de Visita', number: '02' },
    { key: 'VISITA_CONFIRMADA', title: 'Visita Confirmada', number: '03' },
    { key: 'PRESENTACION_OFERTA', title: 'Presentación de Oferta', number: '04' },
    { key: 'EVALUACION_OFERTA', title: 'Evaluación de Oferta', number: '05' },
    { key: 'SEPARACION', title: 'Separación', number: '06' },
    { key: 'PROMESA_COMPRAVENTA', title: 'Promesa de Compraventa', number: '07' },
    { key: 'GESTION_ESCRITURACION', title: 'Gestión de Escrituración', number: '08' },
    { key: 'ENTREGA', title: 'Entrega', number: '09' }
];